export const PERMISSIONS = [
  'Create',
  'Read',
  'Update',
  'Delete',
  'Approve',
  'Verify',
  'Export',
  'Manage Users',
  'Manage Regions',
  'Manage KPI',
  'Manage System',
] as const

export type Permission = (typeof PERMISSIONS)[number]

export const ROLES = [
  'Super Admin Nasional',
  'Administrator Nasional',
  'Kepala BINDA',
  'Wakil Kepala BINDA',
  'Admin BINDA',
  'Analis',
  'Koordinator Wilayah',
  'Operator Command Center',
  'Personel Lapangan',
] as const

export type Role = (typeof ROLES)[number]

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  'Super Admin Nasional': [...PERMISSIONS],
  'Administrator Nasional': [
    'Create',
    'Read',
    'Update',
    'Export',
    'Manage Users',
    'Manage Regions',
    'Manage KPI',
  ],
  'Kepala BINDA': ['Read', 'Approve', 'Export'],
  'Wakil Kepala BINDA': ['Read', 'Export'],
  'Admin BINDA': [
    'Create',
    'Read',
    'Update',
    'Delete',
    'Export',
    'Manage Users',
  ],
  Analis: ['Read', 'Update', 'Verify', 'Export'],
  'Koordinator Wilayah': ['Read', 'Update', 'Export'],
  'Operator Command Center': ['Read', 'Export'],
  'Personel Lapangan': ['Create', 'Read', 'Update'],
}

export const DUMMY_ACCOUNTS = [
  {
    id: 'SA-001',
    username: 'admin.nasional',
    name: 'Jenderal Budi',
    role: 'Super Admin Nasional',
    region: 'Nasional',
    roles: ['Super Admin Nasional'],
  },
  {
    id: 'ADM-001',
    username: 'admin.ops',
    name: 'Kolonel Andi',
    role: 'Administrator Nasional',
    region: 'Nasional',
    roles: ['Administrator Nasional', 'Analis'],
  },
  {
    id: 'KB-SU',
    username: 'kb.sumut',
    name: 'Brigjen Daud',
    role: 'Kepala BINDA',
    region: 'Sumatera Utara',
    roles: ['Kepala BINDA'],
  },
  {
    id: 'KB-RI',
    username: 'kb.riau',
    name: 'Brigjen Rizal',
    role: 'Kepala BINDA',
    region: 'Riau',
    roles: ['Kepala BINDA'],
  },
  {
    id: 'WKB-JB',
    username: 'wkb.jabar',
    name: 'Kolonel Dedi',
    role: 'Wakil Kepala BINDA',
    region: 'Jawa Barat',
    roles: ['Wakil Kepala BINDA'],
  },
  {
    id: 'AB-JB',
    username: 'admin.jabar',
    name: 'Mayor Cipto',
    role: 'Admin BINDA',
    region: 'Jawa Barat',
    roles: ['Admin BINDA'],
  },
  {
    id: 'AN-HQ',
    username: 'analis.hq',
    name: 'Kapten Rina',
    role: 'Analis',
    region: 'Nasional',
    roles: ['Analis'],
  },
  {
    id: 'AN-JB',
    username: 'analis.jabar',
    name: 'Lettu Bayu',
    role: 'Analis',
    region: 'Jawa Barat',
    roles: ['Analis'],
  },
  {
    id: 'KW-JB',
    username: 'koor.jabar',
    name: 'Kapten Surya',
    role: 'Koordinator Wilayah',
    region: 'Jawa Barat',
    roles: ['Koordinator Wilayah'],
  },
  {
    id: 'OP-CC',
    username: 'op.cc.1',
    name: 'Sersan Tejo',
    role: 'Operator Command Center',
    region: 'Nasional',
    roles: ['Operator Command Center'],
  },
  {
    id: 'PL-001',
    username: 'agen.alpha',
    name: 'Agen Alpha',
    role: 'Personel Lapangan',
    region: 'DKI Jakarta',
    roles: ['Personel Lapangan'],
  },
  {
    id: 'MULTI-01',
    username: 'multi.role',
    name: 'Mayor Jenderal Multi',
    role: 'Kepala BINDA',
    region: 'DKI Jakarta',
    roles: ['Kepala BINDA', 'Analis', 'Operator Command Center'],
  },
]

export const ROUTE_ACCESS: Record<string, Role[]> = {
  '/ukstr': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Admin BINDA',
    'Analis',
    'Koordinator Wilayah',
  ],
  '/': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Analis',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Admin BINDA',
    'Koordinator Wilayah',
  ],
  '/regional': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Analis',
    'Koordinator Wilayah',
  ],
  '/reports': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Analis',
    'Koordinator Wilayah',
  ],
  '/kpi': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Koordinator Wilayah',
  ],
  '/alerts': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Analis',
    'Koordinator Wilayah',
  ],
  '/notifications': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Analis',
    'Koordinator Wilayah',
    'Operator Command Center',
  ],
  '/command-center': ['Super Admin Nasional', 'Operator Command Center'],
  '/personnel': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Kepala BINDA',
    'Wakil Kepala BINDA',
    'Koordinator Wilayah',
  ],
  '/users': ['Super Admin Nasional', 'Administrator Nasional', 'Admin BINDA'],
  '/master-data': ['Super Admin Nasional', 'Administrator Nasional'],
  '/audit-log': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
  ],
  '/executive': ['Super Admin Nasional', 'Kepala BINDA', 'Wakil Kepala BINDA'],
  '/settings': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
  ],
  '/design-system': [
    'Super Admin Nasional',
    'Administrator Nasional',
    'Admin BINDA',
    'Analis',
  ],
  '/mobile': ['Personel Lapangan'],
}

export function isRouteAllowed(path: string, role: Role): boolean {
  if (path === '/login' || path === '/unauthorized') return true

  if (ROUTE_ACCESS[path] && ROUTE_ACCESS[path].includes(role)) return true

  const baseRoute = '/' + path.split('/')[1]
  if (ROUTE_ACCESS[baseRoute] && ROUTE_ACCESS[baseRoute].includes(role))
    return true

  return false
}

export function hasPermission(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false
}
